import React, { useEffect } from "react";
import {
  addPortalSettings,
  useGetPortalSettingMutation,
} from "../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import PageLoader from "../../compenents/app/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { AppState } from "../../redux/reducer/rootReducer";
import { useNavigate } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { Parts } from "../../compenents/ShoppingPortal/Parts";
import { EmbeddedParts } from "../../compenents/ShoppingPortal/EmbeddedParts";
import { PortalManufacturers } from "../../compenents/ShoppingPortal/PortalManufacturers";

export const PartsPortalManufacturer: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<Dispatch<any>>();
  const { portalSettings, expiryTime } = useSelector(
    (state: AppState) => state.shoppingPortalReducer
  );
  const portalUrl = useSelector(
    (state: AppState) => state.shoppingPortalReducer.storeUrl
  );
  const currentTime = Date.now();
  const urlSearchParams = new URLSearchParams(window.location.search);
  let storeUrl = urlSearchParams.get("store");
  const [getPortalSettingMutation, getPortalSettingMutationResult] =
    useGetPortalSettingMutation();

  useEffect(() => {
    if (
      portalSettings === undefined ||
      portalUrl !== storeUrl ||
      currentTime > expiryTime
    ) {
      getPortalSettingMutation({ storeUrl: storeUrl ?? "" });
    }
  }, [portalSettings]);
  useEffect(() => {
    if (
      getPortalSettingMutationResult.data &&
      getPortalSettingMutationResult.isSuccess
    ) {
      if (getPortalSettingMutationResult.data.status === 200) {
        if (getPortalSettingMutationResult.data.entity) {
          const expiryTime = currentTime + 60 * 60 * 1000;
          dispatch(
            addPortalSettings({
              settings: getPortalSettingMutationResult.data.entity,
              storeUrl: storeUrl ?? "",
              logoUrl:
                getPortalSettingMutationResult.data.entity?.setting.images.find(
                  (img) => img.type === "Logo"
                )?.absoluteUrl ?? "",
              expiryTime: expiryTime,
            })
          );
        }
      } else {
        console.log("Not found", getPortalSettingMutationResult.data);
        navigate("/invalid-URL");
      }
    }
  }, [getPortalSettingMutationResult]);

  return (
    <>
      {getPortalSettingMutationResult.isLoading ? (
        <Container
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          maxWidth="sm"
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 5,
            }}
          >
            <CircularProgress color="primary" size="2rem" />

            <Typography fontSize="1rem" textAlign="center">
              Loading Store Settings...
            </Typography>
          </Box>
        </Container>
      ) : (
        <>
          <PortalManufacturers></PortalManufacturers>
        </>
      )}
    </>
  );
};
